import React, { FC } from 'react';
import CustomModal from 'shared/components/andtComponents/Modal';
import styles from '../GovernanceTagsModal.module.scss';

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  selectedTagIndices: Set<number>;
  totalTags: number;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  isOpen,
  isLoading,
  selectedTagIndices,
  totalTags,
  onClose,
  onConfirm,
}) => {
  return (
    <CustomModal
      open={isOpen}
      onClose={onClose}
      title="Remove Selected Virtual Tags"
      overrideStyles={{ width: 480 }}
      saveDisabled={isLoading}
      onSave={onConfirm}
      saveTitle="Remove"
      saveWarning
      headerMode="simple"
      isLoading={isLoading}
    >
      <div className={styles.deleteConfirmContent}>
        {selectedTagIndices.size === totalTags ? (
          <p>Are you sure you want to remove all virtual tags from this resource?</p>
        ) : (
          <p>Are you sure you want to remove the selected virtual tags from this resource?</p>
        )}
        <p>This action cannot be undone.</p>
      </div>
    </CustomModal>
  );
};

export default DeleteConfirmationModal;
